// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";

import { FormControl, FormLabel } from "@chakra-ui/react";
import SelectMultipleInvite from "src/components/user/SelectMultipleInvite";

import type { UID, Email, GroupId } from "src/types";

type Member = UID | Email;

type Props = {
  members: Array<Member>,
  groups?: Array<GroupId>,
  handleMembers: (member: UID | Email) => void,
  handleGroups?: (group: GroupId) => void
};

const Members = ({ members, handleMembers, groups, handleGroups }: Props) => (
  <FormControl p={4}>
    <FormLabel onClick={e => e.preventDefault()}>
      {i18n.t(k.PARTICIPANTS)}
    </FormLabel>
    <SelectMultipleInvite
      members={members}
      groups={groups}
      handleMembers={handleMembers}
      handleGroups={handleGroups}
    />
  </FormControl>
);

export default Members;
